import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import SocialProof from '../views/SocialProof.vue';
import HuddleWcurves from '../views/huddleWcurves.vue';
import TestimonialGrid from '../views/TestimonialGrid.vue';
import FyloLanding from '../views/FyloLanding.page.vue';
import ColumnPreviewComponents from '../views/component-preview-columns.vue';
import FourCardFeatureSection from '../views/fourCardFeatureSection.vue';
import FyloTwoColumnLanding from '../views/FyloTwoColumn.vue';
import Blogr from '../views/Blogr.vue';
import Clipboard from '../views/Clipboard.vue';
import Crowdfunding from '../views/Crowdfunding.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/social-proof-section',
    name: 'SocialProof',
    component: SocialProof,
  },
  {
    path: '/huddle-w-curves',
    name: 'HuddleWcurves',
    component: HuddleWcurves,
  },
  {
    path: '/testimonial-grid',
    name: 'TestimonialGrid',
    component: TestimonialGrid,
  },
  {
    path: '/fylo-landing',
    name: 'FyloLanding',
    component: FyloLanding,
  },
  {
    path: '/column-preview',
    name: 'ColumnPreviewComponents',
    component: ColumnPreviewComponents,
  },
  {
    path: '/four-card-feature-section',
    name: 'FourCardFeatureSection',
    component: FourCardFeatureSection,
  },
  {
    path: '/fylo-2-column-landing-page',
    name: 'FyloTwoColumnLanding',
    component: FyloTwoColumnLanding,
  },
  {
    path: '/blogr',
    name: 'Blogr',
    component: Blogr,
  },
  {
    path: '/clipboard',
    name: 'Clipboard',
    component: Clipboard,
  },
  {
    path: '/crowdfunding',
    name: 'Crowdfunding',
    component: Crowdfunding,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
